function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Bulk Update", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_3 = {
  "class": "rounded-lg w-full mx-auto bg-white p-6"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  "class": "flex justify-between items-center px-4 py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h6", {
  "class": "text-sm font-bold"
}, "Campaign Settings")], -1);
var _hoisted_5 = {
  "class": "py-3"
};
var _hoisted_6 = {
  "class": "mb-4 flex items-center"
};
var _hoisted_7 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_8 = {
  "class": "flex items-center"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Follow up start time", -1);
var _hoisted_10 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_11 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_12 = {
  "class": "flex items-center"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Follow up end time", -1);
var _hoisted_14 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_15 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_16 = {
  "class": "flex items-center"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Follow interval", -1);
var _hoisted_18 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_19 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_20 = {
  "class": "flex items-center"
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum number of people to be contacted per company in a day", -1);
var _hoisted_22 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_23 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_24 = {
  "class": "flex items-center"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum number of emails to be sent per campaigner per min", -1);
var _hoisted_26 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_27 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_28 = {
  "class": "flex items-center"
};
var _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum fresh contacts to be reached out per campaigner per day", -1);
var _hoisted_30 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_31 = {
  "class": "bg-gray-100 w-full p-3 mb-2 flex justify-between items-center border border-fborder rounded-md"
};
var _hoisted_32 = {
  "class": "flex items-center"
};
var _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm"
}, "Maximum emails to be sent per campaigner per day", -1);
var _hoisted_34 = {
  "class": "flex items-center justify-center gap-2 w-1/6"
};
var _hoisted_35 = {
  "class": "w-full flex justify-center items-center"
};
var _hoisted_36 = {
  "class": "rounded-xl"
};
var _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  "class": "py-2 w-full"
}, [/*#__PURE__*/_createElementVNode("h6", {
  "class": "font-bold"
}, "Campaign Setting Change Logs")], -1);
var _hoisted_38 = {
  "class": "pl-4 space-y-1"
};
var _hoisted_39 = {
  key: 0
};
var _hoisted_40 = {
  key: 0
};
var _hoisted_41 = {
  key: 1
};
var _hoisted_42 = {
  "class": "flex justify-center cursor-help font-medium capitalize"
};
var _hoisted_43 = {
  "class": "flex justify-center font-medium capitalize"
};
var _hoisted_44 = {
  key: 1,
  "class": "mt-4 flex justify-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_time_select = _resolveComponent("el-time-select");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_tooltip = _resolveComponent("el-tooltip");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_pagination = _resolveComponent("el-pagination");
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");
  var _component_el_collapse = _resolveComponent("el-collapse");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Bulk Update"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
    multiple: "",
    filterable: "",
    modelValue: $data.campaignSettings.tenant_list,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.campaignSettings.tenant_list = $event;
    }),
    "class": "w-full",
    placeholder: "Select Tenants",
    size: "large"
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.internalTenants, function (tenant) {
        return _openBlock(), _createBlock(_component_el_option, {
          label: tenant.id,
          value: tenant.id
        }, null, 8, ["label", "value"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.selectedSettings.follow_up_time = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.follow_up_time]]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_time_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.follow_up_time,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.campaignSettings.follow_up_time = $event;
    }),
    disabled: !$data.selectedSettings.follow_up_time,
    start: "00:00",
    step: "00:30",
    end: "23:59",
    "max-time": $data.campaignSettings.follow_up_end_time,
    placeholder: "Not Applicable",
    format: "HH:mm"
  }, null, 8, ["modelValue", "disabled", "max-time"])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.selectedSettings.follow_up_end_time = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.follow_up_end_time]]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_time_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.follow_up_end_time,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.campaignSettings.follow_up_end_time = $event;
    }),
    disabled: !$data.selectedSettings.follow_up_end_time,
    start: "00:00",
    step: "00:30",
    end: "23:59",
    "min-time": $data.campaignSettings.follow_up_time,
    placeholder: "Not Applicable",
    format: "HH:mm"
  }, null, 8, ["modelValue", "disabled", "min-time"])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return $data.selectedSettings.interval = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.interval]]), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_input, {
    "class": "w-32",
    modelValue: $data.campaignSettings.interval,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.campaignSettings.interval = $event;
    }),
    disabled: !$data.selectedSettings.interval,
    placeholder: "1,2,3,4"
  }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
      return $data.selectedSettings.contacts_per_company = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.contacts_per_company]]), _hoisted_21]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.contacts_per_company,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.campaignSettings.contacts_per_company = $event;
    }),
    disabled: !$data.selectedSettings.contacts_per_company
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, function (n) {
        return _createVNode(_component_el_option, {
          key: n,
          value: n
        }, null, 8, ["value"]);
      }), 64))];
    }),
    _: 1
  }, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return $data.selectedSettings.emails_per_minute = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.emails_per_minute]]), _hoisted_25]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_el_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.emails_per_minute,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.campaignSettings.emails_per_minute = $event;
    }),
    disabled: !$data.selectedSettings.emails_per_minute
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, function (n) {
        return _createVNode(_component_el_option, {
          key: n,
          value: n
        }, null, 8, ["value"]);
      }), 64))];
    }),
    _: 1
  }, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
      return $data.selectedSettings.emails_per_day = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.emails_per_day]]), _hoisted_29]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.emails_per_day,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.campaignSettings.emails_per_day = $event;
    }),
    disabled: !$data.selectedSettings.emails_per_day
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        value: 50
      }), _createVNode(_component_el_option, {
        value: 100
      }), _createVNode(_component_el_option, {
        value: 150
      }), _createVNode(_component_el_option, {
        value: 200
      }), _createVNode(_component_el_option, {
        value: 300
      }), _createVNode(_component_el_option, {
        value: 500
      })];
    }),
    _: 1
  }, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_withDirectives(_createElementVNode("input", {
    type: "checkbox",
    "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) {
      return $data.selectedSettings.emails_per_day_total = $event;
    }),
    "class": "mr-2 transform scale-125"
  }, null, 512), [[_vModelCheckbox, $data.selectedSettings.emails_per_day_total]]), _hoisted_33]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_el_select, {
    "class": "w-32",
    modelValue: $data.campaignSettings.emails_per_day_total,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.campaignSettings.emails_per_day_total = $event;
    }),
    disabled: !$data.selectedSettings.emails_per_day_total
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        value: 250
      }), _createVNode(_component_el_option, {
        value: 500
      }), _createVNode(_component_el_option, {
        value: 750
      }), _createVNode(_component_el_option, {
        value: 1000
      }), _createVNode(_component_el_option, {
        value: 1500
      }), _createVNode(_component_el_option, {
        value: 2000
      }), _createVNode(_component_el_option, {
        value: 2500
      })];
    }),
    _: 1
  }, 8, ["modelValue", "disabled"])])])])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
    onClick: _cache[15] || (_cache[15] = function () {
      return $options.resetCampaignSettings && $options.resetCampaignSettings.apply($options, arguments);
    })
  }, "Reset Changes"), _createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 p-2 rounded-md",
    onClick: _cache[16] || (_cache[16] = function () {
      return $options.saveCampaignSettings && $options.saveCampaignSettings.apply($options, arguments);
    })
  }, "Save Changes")])])]), _createElementVNode("div", _hoisted_36, [_createVNode(_component_el_collapse, {
    "class": "mt-6"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_37, _createVNode(_component_el_collapse_item, null, {
        "default": _withCtx(function () {
          var _$data$settingChanges, _$data$settingChanges2, _$data$settingChanges3;
          return [(_$data$settingChanges = $data.settingChanges) !== null && _$data$settingChanges !== void 0 && (_$data$settingChanges2 = _$data$settingChanges.data) !== null && _$data$settingChanges2 !== void 0 && _$data$settingChanges2.length ? (_openBlock(), _createBlock(_component_el_table, {
            key: 0,
            data: $data.settingChanges.data,
            style: {
              "width": "100%"
            }
          }, {
            "default": _withCtx(function () {
              return [_createVNode(_component_el_table_column, {
                prop: "id",
                label: "ID",
                "min-width": "60"
              }), _createVNode(_component_el_table_column, {
                label: "Settings Changed",
                "min-width": "400"
              }, {
                "default": _withCtx(function (_ref) {
                  var row = _ref.row;
                  return [_createElementVNode("div", _hoisted_38, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.settings_changed, function (value, key) {
                    return _openBlock(), _createElementBlock("div", {
                      key: key
                    }, [value && _typeof(value) === 'object' && !Array.isArray(value) ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(key) + ":", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, function (subValue, subKey) {
                      return _openBlock(), _createElementBlock("div", {
                        key: subKey,
                        "class": "pl-6 ml-4"
                      }, [subValue ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(subKey) + ": " + _toDisplayString(subValue), 1)) : _createCommentVNode("", true)]);
                    }), 128))])) : Array.isArray(value) && value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(key) + ":", 1), _createTextVNode(" " + _toDisplayString(value.join(', ')), 1)])])) : _createCommentVNode("", true)]);
                  }), 128))])];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "Job Status",
                "min-width": "140",
                "header-align": "center"
              }, {
                "default": _withCtx(function (_ref2) {
                  var row = _ref2.row;
                  return [_createVNode(_component_el_tooltip, {
                    "class": "item",
                    effect: "dark",
                    content: row.status.details || 'No details',
                    placement: "top"
                  }, {
                    "default": _withCtx(function () {
                      return [_createElementVNode("span", {
                        "class": _normalizeClass("flex justify-center font-medium capitalize text-".concat(row.status.status === 'success' ? 'green' : row.status.status === 'failed' ? 'red' : 'yellow', "-500"))
                      }, _toDisplayString(row.status.status || 'N/A'), 3)];
                    }),
                    _: 2
                  }, 1032, ["content"])];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "Job Created By",
                "min-width": "140",
                "header-align": "center"
              }, {
                "default": _withCtx(function (_ref3) {
                  var row = _ref3.row;
                  return [_createElementVNode("span", _hoisted_42, _toDisplayString(row.user.name || 'N/A'), 1)];
                }),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "Created on",
                "min-width": "140",
                "header-align": "center"
              }, {
                "default": _withCtx(function (_ref4) {
                  var row = _ref4.row;
                  return [_createElementVNode("span", _hoisted_43, _toDisplayString(row.updated_at), 1)];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["data"])) : _createCommentVNode("", true), (_$data$settingChanges3 = $data.settingChanges) !== null && _$data$settingChanges3 !== void 0 && _$data$settingChanges3.meta ? (_openBlock(), _createElementBlock("div", _hoisted_44, [_createVNode(_component_el_pagination, {
            background: "",
            layout: "prev, pager, next",
            total: $data.settingChanges.meta.total,
            "current-page": $data.settingChanges.meta.current_page,
            "page-size": $data.settingChanges.meta.per_page,
            onCurrentChange: $options.handlePageChange
          }, null, 8, ["total", "current-page", "page-size", "onCurrentChange"])])) : _createCommentVNode("", true)];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]);
}